module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: _vm.column.decorator,
    style: (_vm.getStyle()),
    attrs: {
      "rowspan": _vm.rowspan
    }
  }, [((_vm.secondaryIndex === 0) || (_vm.column.path ? _vm.column.path : '').includes('[]')) ? _c('div', [(_vm.column.decorator !== 'composite' && _vm.checkField(_vm.column, _vm.product)) ? _c('tablefield-' + _vm.column.decorator, {
    tag: "component",
    class: [_vm.column.decorator],
    attrs: {
      "config": _vm.column,
      "data": _vm.getCellData(_vm.column, _vm.product, _vm.secondaryIndex),
      "product": _vm.product,
      "singleLine": _vm.singleLine,
      "name": "base"
    }
  }) : (_vm.column.decorator === 'composite') ? _c('div', _vm._l((_vm.column.decoratorOptions.lines), function(subField, index) {
    return (_vm.checkField(subField, _vm.product)) ? _c('tablefield-' + subField.decorator, {
      key: index,
      tag: "component",
      class: subField.decorator,
      attrs: {
        "config": subField,
        "data": _vm.getCellData(subField, _vm.product, _vm.secondaryIndex),
        "product": _vm.product,
        "singleLine": _vm.singleLine
      }
    }) : _c('div', {
      class: {
        'single-line': _vm.singleLine
      }
    }, [_vm._v("—")])
  }), 1) : _c('div', [_vm._v("—")])], 1) : _c('div')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edcdb2fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldContainer.vue
// module id = 725
// module chunks = 0